import GroupsHome from './GroupsHome';

export default GroupsHome;
